import React from "react";
import { Link } from "react-router-dom";

const posts = [
  {
    slug: "checklista-dobrych-praktyk-wnioski-grantowe",
    category: "Dobre praktyki",
    title: "Checklista dobrych praktyk przy pisaniu wniosków grantowych",
    excerpt:
      "Pozyskiwanie dotacji wymaga precyzji, strategii i dbałości o detale. Ta checklista prowadzi przez kluczowe obszary: kwalifikowalność, spójność i logikę projektu, realistyczny budżet, doświadczenie zespołu, kompletność załączników oraz zasadę 4 oczu.",
    readTime: "4 min",
    date: "2025-08-05",
  },
  {
    slug: "najczestsze-bledy-we-wnioskach-i-jak-ich-unikac",
    category: "Dobre praktyki",
    title: "Najczęstsze błędy we wnioskach i jak ich unikać",
    excerpt:
      "Niespójna logika projektu, nierealistyczny budżet i harmonogram, słabe uzasadnienie, nieadekwatne wskaźniki, błędy formalne oraz zbyt skomplikowany język — sprawdź, jak ich uniknąć i podnieść ocenę swojego wniosku.",
    readTime: "5 min",
    date: "2025-08-07",
  },
  {
    slug: "nasza-metodyka-3-warstwowa-strategia-sukcesu",
    category: "Nasze podejście",
    title: "Nasza metodyka: 3-warstwowa strategia sukcesu",
    excerpt:
      "Warstwa strategiczna, merytoryczna i wykonawcza tworzą spójny system: od dopasowania programu i planowania celów, przez tworzenie treści i budżetu, po wsparcie w ocenie i realizacji projektu.",
    readTime: "6 min",
    date: "2025-08-08",
  },
  {
    slug: "system-qaqa-do-kontroli-jakosci-wnioskow",
    category: "Nasze podejście",
    title: "QA/QA+: nasz system kontroli jakości wniosków",
    excerpt:
      "Podwójna weryfikacja (zasada 4 oczu), checklisty formalne i merytoryczne, scoring ryzyka, symulacja oceny i ciągłe doskonalenie — tak minimalizujemy błędy i maksymalizujemy szanse na dofinansowanie.",
    readTime: "5 min",
    date: "2025-08-09",
  },
];

const BlogList = () => {
  return (
    <section className="blog-list" id="main" role="main">
      <div className="container">
        <div className="section-header">
          <div className="section-subtitle">Blog</div>
          <h2>Wiedza i metodyka Jasnych Grantów</h2>
          <p>
            Dobre praktyki oraz nasze strategie pracy nad wnioskami – zebrane w
            krótkich, konkretnych artykułach.
          </p>
        </div>

        <div className="services-grid">
          {posts.map((post) => (
            <article
              key={post.slug}
              className="service-card"
              aria-labelledby={`title-${post.slug}`}
            >
              <div className="service-icon" aria-hidden="true">
                <i
                  className={
                    post.category === "Dobre praktyki"
                      ? "fas fa-lightbulb"
                      : "fas fa-cogs"
                  }
                ></i>
              </div>
              <p
                style={{
                  margin: 0,
                  color: "var(--text-muted)",
                  fontSize: "0.875rem",
                }}
              >
                {post.category} · {post.readTime} ·{" "}
                {new Date(post.date).toLocaleDateString("pl-PL")}
              </p>
              <h3 id={`title-${post.slug}`} style={{ marginTop: 8 }}>
                {post.title}
              </h3>
              <p>{post.excerpt}</p>
              <Link
                to={`/blog/${post.slug}`}
                className="btn btn-outline"
                aria-label={`Czytaj: ${post.title}`}
              >
                Czytaj dalej
              </Link>
            </article>
          ))}
        </div>

        <div style={{ marginTop: 40, textAlign: "center" }}>
          <Link
            to="/"
            className="btn btn-primary"
            aria-label="Przejdź na stronę główną"
          >
            ← Strona główna
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogList;
